export default "/_next/static/assets/images/sprite.19eea4dd0322d2d7cffc7a4d33ee3cd2.svg";